module.exports = __webpack_public_path__ + "static/media/instagram.6866bf1f.svg";